<template>
    <div class="top" id="topHeader">
        <div class="top-content">
            <h1>
                <img
                    v-if="$store.state.clientele.imageAddress"
                    :src="$store.state.clientele.imageAddress"
                    alt=""
                />
                <img v-else src="../../../static/images/logo-white.png" alt="" />{{
                    $store.state.clientele.displayName
                }}
            </h1>
            <div class="top-content-right">
                <span style="margin-right: 30px">{{ $store.state.clientele.slogan }}</span>
                <a-popover placement="bottom" v-if="$store.state.userWeixin.openApplet">
                    <template #content>
                        <!-- 不同地区码对应的小程序码图片 imgApplet/*/app_img.jpg-->
                        <!-- <img src="../../../static/imgApplet/ik9YaoxW/app_img.jpg" width="150" alt=""/> -->
                        <img :src="$store.state.clientele.appImageAddress" width="150" alt="" />
                    </template>
                    <span>微信小程序</span> |
                </a-popover>
                <a-dropdown :trigger="['click']" placement="bottomCenter">
                    <a class="ant-dropdown-link" href="#" style="color: white">
                        <img :src="userAvatar" alt="" />
                        <span v-cloak>{{
                            $store.state.userWeixin.phone || $store.state.userWeixin.nickname
                        }}</span>
                    </a>
                    <a-menu slot="overlay" class="cccc">
                        <a-menu-item key="0">
                            <router-link to="/Select">开始自检</router-link>
                        </a-menu-item>
                        <a-menu-item key="1">
                            <router-link to="/Info">我的企业</router-link>
                        </a-menu-item>
                        <a-menu-item key="2">
                            <router-link to="/Record">自检记录</router-link>
                        </a-menu-item>
                        <a-menu-item key="3">
                            <a @click="showModal">修改密码</a>
                        </a-menu-item>
                    </a-menu>
                </a-dropdown>
                <a @click="toLogin"><img src="../../../static/images/exit.png" alt="" /></a>
            </div>
        </div>
        <a-modal
            title="修改密码"
            v-model="visible"
            @ok="handleOk"
            okText="确定"
            cancelText="取消"
            :maskClosable="maskClosable"
            :destroyOnClose="destroyOnClose"
        >
            <a-form :form="form">
                <a-form-item :label-col="{ span: 6 }" :wrapper-col="{ span: 15 }" label="原密码">
                    <a-input
                        type="password"
                        ref="oldPwd"
                        v-decorator="[
                            'oldPwd',
                            {
                                rules: [
                                    { required: true, message: '请输入原密码' },
                                    { pattern: regNumberEndLetter, message: '请输入数字或字母' },
                                ],
                            },
                        ]"
                        autocomplete="new-password"
                    />
                </a-form-item>
                <a-form-item :label-col="{ span: 6 }" :wrapper-col="{ span: 15 }" label="新密码">
                    <a-input
                        type="password"
                        ref="newPwd"
                        v-decorator="[
                            'newPwd',
                            {
                                rules: [
                                    { required: true, message: '请输入新密码' },
                                    { pattern: regNumberEndLetter, message: '请输入数字或字母' },
                                ],
                            },
                        ]"
                        autocomplete="new-password"
                    />
                </a-form-item>
                <a-form-item :label-col="{ span: 6 }" :wrapper-col="{ span: 15 }" label="确认密码">
                    <a-input
                        type="password"
                        v-decorator="[
                            'confirmNewPwd',
                            {
                                rules: [
                                    { required: true, message: '请确认密码' },
                                    { validator: this.checkContent.bind(this) },
                                ],
                            },
                        ]"
                        autocomplete="new-password"
                    />
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
    import { apiListPC } from '@/api'
    import md5 from 'js-md5'
    import ajax from '@/api/ajax'

    import { REGEXP_NUMBER_END_LETTER } from '@/utils/public/RegExp'

    export default {
        name: 'Header',
        data() {
            return {
                visible: false,
                maskClosable: false, //点击遮罩层是否关闭对话框
                form: this.$form.createForm(this),
                newPwd: '',
                destroyOnClose: true,
                regNumberEndLetter: REGEXP_NUMBER_END_LETTER,
            }
        },
        computed: {
            userAvatar() {
                return (
                    this.$store.state.userWeixin.avatar ||
                    require('../../../static/images/sculpture.png')
                )
            },
        },
        watch: {
            $route: {
                handler(route) {
                    const excluderRouteList = [null, 'Login', 'Register', 'Reset', 'ipLocation']
                    if (
                        excluderRouteList.includes(route.name) ||
                        (route.name == 'Report' && !!route.query.authentication) ||
                        route.name == 'Empty'
                    ) {
                        return false
                    }
                    this.$store.dispatch('getUserInfo')
                },
                immediate: true,
            },
        },
        methods: {
            showModal() {
                this.visible = true
            },
            handleOk() {
                this.form.validateFields((err) => {
                    if (!err) {
                        //ajax请求验证原密码 并修改密码
                        let that = this
                        const paramsData = {
                            // newPwd: md5(this.$refs.newPwd.value).toUpperCase(),
                            password: md5(this.$refs.oldPwd.value).toUpperCase(),
                        }
                        ajax(
                            `${apiListPC.modifyPassword}?newPwd=${md5(
                                this.$refs.newPwd.value
                            ).toUpperCase()}`,
                            paramsData,
                            'PUT'
                        )
                            .then(function () {
                                that.$message.success('修改成功')
                                that.visible = false
                            })
                            .catch(function (data) {
                                if (data.returnInfo === '旧密码错误') {
                                    that.$message.warn('旧密码错误')
                                } else {
                                    that.$message.warn('修改失败，请重新尝试')
                                }
                            })
                    }
                })
            },
            checkContent(rule, value, callBack) {
                if (value !== this.$refs.newPwd.value) {
                    callBack('两次密码输入不一致')
                }
                callBack()
            },
            toLogin() {
                this.$router.replace('Login')
                localStorage.setItem('token', '')
            },
        },
    }
</script>

<style lang="less" type="text/less" scoped>
    .top {
        width: 100%;
        height: 70px;
        line-height: 70px;
        background: url('../../../static/images/title-bg1.jpg') 100% 100%;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);

        .top-content {
            width: 1066px;
            height: 100%;
            margin: 0 auto;

            h1 {
                float: left;
                color: #fff;
                font-size: 28px;
                font-weight: 700;
                span {
                    display: inline-block;
                    border: 1px solid #fff;
                    font-size: 14px;
                    color: #fff;
                    border-radius: 2px;
                    line-height: 18px;
                    padding: 0 3px;
                    margin-left: 10px;
                    position: relative;
                    top: -2px;
                    font-weight: normal;
                }
                img {
                    width: 40px;
                    height: 40px;
                    vertical-align: middle;
                    margin-right: 5px;
                    position: relative;
                    top: -2px;
                }
            }

            .top-content-right {
                text-align: right;
                color: #fff;
                font-size: 16px;

                img {
                    margin-left: 15px;
                    cursor: pointer;
                    width: 24px;
                    height: 24px;
                }
            }
        }
    }
    .cccc .ant-dropdown-menu-item > a {
        text-align: center;
    }
</style>
